import CardDiv from "modules/common/card-div/CardDiv";
import GroupManagementTable from "modules/group_management/GroupManagementTable";
import { useGroupManagement } from "modules/group_management/store";
import React, { useEffect, useState } from "react";
import { CloseButton, Modal } from "react-bootstrap";
import { Button, Form, Input, Radio, Row, Select } from "antd";
import { isEmpty } from "lodash";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { userGroupAccess } from "modules/utilities/utility";

function GroupManagement() {
  const {
    groupData,
    userData,
    groupLoading,
    userLoading,
    createLoading,
    fetchGroupData,
    fetchUserData,
    createdGroup,
  } = useGroupManagement();
  const [form] = Form.useForm();
  const [modalShow, setModalShow] = useState(false);
  const [role, setRole] = useState("00000000-0000-0000-0000-000000000002");
  const [filteredUsers, setFilteredUser] = useState([]);
  const { setToaster } = useToast();

  useEffect(() => {
    fetchGroupData();
    fetchUserData();
  }, []);

  useEffect(() => {
    const init = async () => {
      const nfilteredUsers = await userData.filter((user) => {
        return userGroupAccess.includes(user.role_id);
      });

      setFilteredUser([...nfilteredUsers]);
    };

    if (isEmpty(userData)) setFilteredUser([]);
    else init();
  }, [userData, role]);

  const handleModalShow = () => {
    setModalShow(!modalShow);
    form.resetFields();
    setRole("00000000-0000-0000-0000-000000000002");
  };

  const handleRoleChange = (event) => {
    setRole(event.target.value);
    form.setFieldsValue({ supervisor_id: "" });
  };

  const onSubmit = async ({ group_name, supervisor_id }) => {
    createdGroup(
      { name: group_name, userId: supervisor_id },
      setToaster,
      fetchGroupData,
      handleModalShow
    );
  };

  return (
    <div>
      <CardDiv
        title={
          <div className="d-flex justify-content-between align-items-center">
            <div className="fs-2">Manage Groups</div>
            <div>
              <Button
                className="btn btn-primary"
                onClick={() => setModalShow(true)}
              >
                Create Group
              </Button>
            </div>
          </div>
        }
        component={
          <GroupManagementTable
            groupData={groupData}
            groupLoading={groupLoading}
            userData={userData}
            userLoading={userLoading}
          />
        }
      />
      <Modal
        show={modalShow}
        onHide={handleModalShow}
        size="md"
        aria-labelledby="contained-modal-title-vtop"
        top
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Create Group
          </Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={handleModalShow}
          />
        </Modal.Header>
        <Modal.Body>
          <div>
            <Row align="middle" justify="center">
              <Form
                form={form}
                initialValues={{ role: "00000000-0000-0000-0000-000000000002" }}
                layout="vertical"
                name="create_group"
                onFinish={onSubmit}
              >
                <Form.Item
                  label="Group Name"
                  name="group_name"
                  rules={[
                    {
                      required: true,
                      message: "Please fill this",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Role"
                  name="role"
                  rules={[
                    {
                      required: true,
                      message: "Please fill this",
                    },
                  ]}
                >
                  <Radio.Group onChange={handleRoleChange}>
                    <Radio value="00000000-0000-0000-0000-000000000002">
                      Medical Rep
                    </Radio>
                    <Radio value="00000000-0000-0000-0000-000000000003">
                      Sales Rep
                    </Radio>
                    <Radio value="00000000-0000-0000-0000-000000000019">
                      Quality
                    </Radio>
                  </Radio.Group>
                </Form.Item>

                <Form.Item
                  label="Supervisor"
                  name="supervisor_id"
                  rules={[
                    {
                      required: true,
                      message: "Please fill this",
                    },
                  ]}
                >
                  <Select
                    loading={userLoading}
                    showSearch
                    style={{ width: 200 }}
                    optionFilterProp="children"
                  >
                    {filteredUsers.map((user) => (
                      <Option value={user.user_id} key={user.user_id}>
                        {user.user.first_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item style={{ textAlign: "center" }}>
                  <Button
                    type="primary"
                    loading={createLoading}
                    htmlType="submit"
                  >
                    Create Group
                  </Button>
                </Form.Item>
              </Form>
            </Row>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleModalShow}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default GroupManagement;
